import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { useEffect, useRef, useState } from "react";

import * as pdfjsLib from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc =
    `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//     "pdfjs-dist/build/pdf.worker.min.mjs",
//     import.meta.url
// ).toString();


const HighlightOverlay = ({ 
    highlightSpan, 
    viewport 
}) => {
    const [x0, y0, x1, y1] = highlightSpan.bbox;
    console.log("x0, y0, x1, y1:", x0, y0, x1, y1);
    console.log("scale", viewport.scale);

    // // PDF → DOM 轉換
    // const left = x0 * viewport.scale;
    // const width = (x1 - x0) * viewport.scale;

    // // const top = (viewport.height - y1) * viewport.scale; // ⚠️ Y 軸反轉
    // const top = y0 * viewport.scale;
    // const height = (y1 - y0) * viewport.scale;

    const left = x0;
    const width = (x1 - x0);
    const top = y0;
    const height = (y1 - y0);

    return (
        <div
            style={{
                position: "absolute",
                left,
                top,
                width,
                height,
                background: "rgba(255, 0, 0, 0.25)",
                border: "2px solid red",
                pointerEvents: "none",
                zIndex: 10,
            }}
        />
    );
}



const PDFViewer = ({ 
    file, 
    page, 
    highlights = [],
    highlightSpan = null
}) => {
    const pageRef = useRef(null);
    const [viewport, setViewport] = useState(null);

    useEffect(() => {
        if (highlightSpan) {
            console.log("highlightSpan bbox:", highlightSpan.bbox);
        }
    }, [highlightSpan]);


    return (<>
        <div style={{ position: "relative" }}>
            <Document file={file}>
                <Page 
                    pageNumber={page} 
                    // width={800} 
                    onLoadSuccess={(pdfPage) => {
                        const renderedScale = pdfPage.getViewport({ scale: 1 }).width
                            ? 800 / pdfPage.getViewport({ scale: 1 }).width
                            : 1;

                        const vp = pdfPage.getViewport({ scale: renderedScale });
                        console.log("Rendered viewport:", vp);
                        setViewport(vp);
                    }}
                    inputRef={pageRef}
                />

                {/* BBOX overlays */}
                {/* {highlights?.map((h, i) => (
                    <div
                        key={i}
                        style={{
                        position: "absolute",
                        left: h.x,
                        top: h.y,
                        width: h.w,
                        height: h.h,
                        border: "2px solid red",
                        pointerEvents: "none",
                        }}
                    />
                ))} */}
            </Document>

            {highlightSpan && viewport && (
                <HighlightOverlay
                    highlightSpan={highlightSpan}
                    viewport={viewport}
                />
            )}
        </div>
    </>);
};

export default PDFViewer;
